module.exports = {"520527001":"双河街道","520527002":"白果街道","520527102":"妈姑镇","520527103":"财神镇","520527104":"六曲河镇","520527105":"野马川镇","520527106":"罗州镇","520527107":"平山镇","520527108":"哲庄镇","520527109":"古基镇","520527110":"朱明镇","520527111":"德卓镇","520527200":"达依乡","520527201":"水塘堡彝族苗族乡","520527202":"兴发苗族彝族回族乡","520527203":"松林坡白族彝族苗族乡","520527204":"雉街彝族苗族乡","520527205":"珠市彝族乡","520527207":"双坪彝族苗族乡","520527208":"铁匠苗族乡","520527209":"辅处彝族苗族乡","520527210":"可乐彝族苗族乡","520527211":"河镇彝族苗族乡","520527213":"安乐溪乡","520527215":"结构彝族苗族乡","520527219":"古达苗族彝族乡","520527220":"威奢乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520527.json
// module id = 2490
// module chunks = 0